import {MenuItem, MenuItemProps} from '@mui/material';

type AppMUIMenuItemProps = {
  children: any;
} & Omit<MenuItemProps, 'sx'>;

function AppMUIMenuItem({children, ...rest}: AppMUIMenuItemProps) {
  return (
    <MenuItem
      {...rest}
      sx={{
        m: 1,
        borderRadius: '8px',
        '&.Mui-selected': {
          backgroundColor: '#BDDDFF',
        },
        '&:hover': {
          backgroundColor: '#D8FEFF',
        },
      }}>
      {children}
    </MenuItem>
  );
}

export default AppMUIMenuItem;
